import { render, staticRenderFns } from "./ExamGrading.vue?vue&type=template&id=11bb7e41&scoped=true"
import script from "./ExamGrading.vue?vue&type=script&lang=js"
export * from "./ExamGrading.vue?vue&type=script&lang=js"
import style0 from "./ExamGrading.vue?vue&type=style&index=0&id=11bb7e41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bb7e41",
  null
  
)

export default component.exports